import * as React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Chip } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';


function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell sx={{ width: "30px" }}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
            hidden={row.history == "false"}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" sx={{ width: "360px" }}>
          {row?.name}
        </TableCell>
        <TableCell align="right" sx={{ width: "172.8px" }}> <Chip
          color="primary"
          label={row?.process}
          sx={{
            borderRadius: "3px",
            backgroundColor: row?.color,
            color: "#FFFFFF",
            width: "90px",
            height: "24px",
          }}
        /></TableCell>
        <TableCell align="right" sx={{ width: "172.8px" }}>{row?.lastWatch}</TableCell>
        <TableCell align="right" sx={{ width: "172.8px" }}>{row?.Exp}</TableCell>
        <TableCell align="center" sx={{ width: "172.8px" }}>{row?.prevpass}</TableCell>
        <TableCell align="right" sx={{ width: "172.8px" }}>{row?.renewal}</TableCell>
        <TableCell align="center" hidden={row.process != "In process"}><PlayArrowOutlinedIcon sx={{ color: "#98A2B3" }} /></TableCell>
      </TableRow>
      <TableRow hidden={row?.history == "false"}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12} >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Button

                style={{ color: "#2A93DB", cursor: "pointer" }}
              >
                <InsertDriveFileOutlinedIcon
                  sx={{
                    marginRight: "5px",
                    color: "#2A93DB",
                    cursor: "pointer",
                  }}
                />
                Training Certificate
              </Button>
              <br />
              <Button sx={{ color: "#2A93DB" }}>
                <InsertDriveFileOutlinedIcon
                  sx={{ marginRight: "5px", color: "#2A93DB" }}
                />
                Download Document
              </Button>
              <Table size="small" aria-label="purchases">

              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}


const rows = [
  {
    "process": "In process",
    "lastWatch": "12/2/1998",
    "Exp": "12/02/2023",
    "renewal": "No",
    "name": "AGCO-Hesston Safety Orientation",
    "color": "#5925DC",
    "prevpass": "-",
    "history": "true",
    "client": "Green plains"
  },
  {
    "process": "Passed",
    "lastWatch": "12/2/1998",
    "Exp": "12/02/2023",
    "renewal": "No",
    "name": " Safety Orientation",
    "color": "#12B76A",
    "prevpass": "-",
    "history": "true",
    "client": "Green plains"


  },
  {
    "process": "In process",
    "lastWatch": "12/2/1998",
    "Exp": "12/02/2023",
    "renewal": "No",
    "name": " Safety ",
    "color": "#5925DC",
    "prevpass": "-",
    "history": "false",
    "client": "Green plains"
  },
  {
    "process": "In process",
    "lastWatch": "12/2/1998",
    "Exp": "12/02/2023",
    "renewal": "Yes",
    "name": " Orientation ",
    "color": "#5925DC",
    "prevpass": "-",
    "history": "true",
    "client": "Ormat Technologies, Inc."
  },
  {
    "process": "In process",
    "lastWatch": "12/2/1998",
    "Exp": "12/02/2023",
    "renewal": "Yes",
    "name": " Orientation2222 ",
    "color": "#5925DC",
    "prevpass": "-",
    "history": "true",
    "client": "AGCO / GSI"
  },
];
const groupByCategory = Object.entries(rows?.reduce((group, product) => {
  const { client } = product;
  group[client] = group[client] ?? [];
  group[client].push(product);
  return group;

}, {}));

const hide = groupByCategory[0]


export default function EmployeeAccessTrainingList() {
  return (
    <>
      <TableContainer component={Paper}>
        {groupByCategory?.map((r) => (
          <>
            <Typography variant="h6" gutterBottom component="div" sx={{ marginLeft: "15px", padding: "10px", marginTop: "5px", color: "#3E4A62" }}>
              {r[0]}
            </Typography>
            <hr style={{ margin: "0rem" }} />
            <Table aria-label="collapsible table">

              <TableHead >
                <TableRow hidden={hide[0] != r[0]}>
                  <TableCell sx={{ backgroundColor: "#F2F4F7" }} />
                  <TableCell sx={{ backgroundColor: "#F2F4F7" }}>Course Name</TableCell>
                  <TableCell align="right" sx={{ backgroundColor: "#F2F4F7" }}>Status</TableCell>
                  <TableCell align="right" sx={{ backgroundColor: "#F2F4F7" }}>Last Watched</TableCell>
                  <TableCell align="right" sx={{ backgroundColor: "#F2F4F7" }}>Expiration Date</TableCell>
                  <TableCell align="right" sx={{ backgroundColor: "#F2F4F7" }}>Previously Passed</TableCell>
                  <TableCell align="right" sx={{ backgroundColor: "#F2F4F7" }}>it a renewal</TableCell>
                  <TableCell align="right" sx={{ backgroundColor: "#F2F4F7" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {r[1]?.map((row) => (
                  <Row key={row?.name} row={row} />
                ))}
              </TableBody>
            </Table>
          </>
        ))}
      </TableContainer>
    </>
  )
}
